import React, { useState } from "react";
import shortid from "shortid";
import { set } from "dot-prop-immutable";
import { Table, Icon } from '@whalecloud/fdx';
import { getLocale } from '@utils/util';

const DefaultValueTable = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = [] } = {} } = element;
  const {
    defaultValue,
  } = formItemSettings;

  let defaultValueArr = []

  if (defaultValue && defaultValue.value) {
    defaultValueArr = defaultValue.value.map(item => {
      item.key = `${shortid.generate()}`;
      return item;
    })
  }

  const [dataSource, setDataSource] = useState(defaultValueArr);
  const [editingKey, setEditingKey] = useState();
  const columns = [
    {
      title: messages['PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_ID'],
      dataIndex: "partyId",
      width: 100,
      editable: true,
      editRules: [{ required: true, message: messages['PAGEBUIDER_SETTINGS_PLEASE_INPUT_NAME'] }]
    },
    {
      title: messages['PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_NAME'],
      dataIndex: "partyName",
      width: 100,
      editable: true,
      editRules: [{ required: true, message: messages['PAGEBUIDER_SETTINGS_PLEASE_INPUT_NAME'] }]
    },
    {
      title: messages['PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_TYPE'],
      dataIndex: "partyType",
      width: 100,
      editable: true,
      editRules: [{ required: true, message: messages['PAGEBUIDER_SETTINGS_PLEASE_INPUT_NAME'] }]
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_OPERATION'],
      dataIndex: "edit",
      width: 100,
      editable: true,
      render: (text, record) => <a onClick={() => { delRow(record.key) }}><Icon type="delete" /></a>,
      editContent: () => <Icon type="edit" />,
      saveContent: () => <Icon type="save" />,
      cancelContent: () => <Icon type="stop" />
    }
  ];
  const delRow = key => {
    const newData = dataSource.filter(item => item.key !== key);
    setDataSource(newData)
    hanldeEleUpdate(newData)
  }

  const addRow = () => {
    const uuid = shortid.generate();
    const data = dataSource.concat({
      key: `${uuid}`,
      name: `default_${uuid}`,
      value: `${uuid}`,
    });
    setDataSource(data);
    setEditingKey(uuid)
    hanldeEleUpdate(data)
  };

  const onSaveRowEdit = (record, newData) => {
    setDataSource(newData);
    hanldeEleUpdate(newData)
  }

  const hanldeEleUpdate = (elements) => {
    const newDefaultnArr = elements.map(ele => {
      const eleObj = {};
      Object.keys(ele).forEach(key => {
        if (key !== 'key') {
          eleObj[key] = ele[key]
        }
      })
      return eleObj
    })

    const results = {
      partyName: newDefaultnArr.map(item => item.partyName).join(','),
      value: newDefaultnArr,
    }
    const newElement = set(element, 'data.formItemSettings.defaultValue', results);
    updateElement({
      element: newElement,
    });
  }

  const footer = () => <a onClick={addRow}>Add new item</a>;
  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{ y: 240 }}
        editRow
        editingKey={editingKey}
        onSaveRowEdit={onSaveRowEdit}
        footer={footer}
      />
    </div>
  );
}

export default DefaultValueTable;
